import { createFileRoute } from '@tanstack/react-router';
import GalleryManagement from '../../components/manager/GalleryManagement';
import StaffPortal from '../../components/portals/StaffPortal';

export const Route = createFileRoute('/staff/media')({
  component: StaffMediaRoute,
});

function StaffMediaRoute() {
  return (
    <StaffPortal>
      <GalleryManagement />
    </StaffPortal>
  );
}
